import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ItemsService } from '@scaffold/services/items.service';
import { CourseService } from '@scaffold/services/course.service';
import { ViewsService } from '@services/views.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { parse } from 'querystring';
import { RenderedService } from '../../rendered.service';
@Component({
  selector: 'scaffold-bulk-input',
  templateUrl: './bulk-input.component.html',
  styleUrls: ['./bulk-input.component.scss']
})

/*
* this component bulk imports data arrays and their children
* @return {} The items
 */

export class BulkInputComponent extends BaseScaffoldComponent implements OnInit {

  constructor(public cdr: ChangeDetectorRef, private itemsService: ItemsService, private courseService: CourseService, public viewService: ViewsService, private viewUpdate: ViewUpdateService, public renderedService: RenderedService) { super(cdr, renderedService); }
  hasSubArray = false;
  bulk_data;
  prefix;
  columns = [];
  creating = false;
  mapped = [];
  created = [];
  ngOnInit() {
    console.log(this.item);
    this.prefix = "";
    if (this.item.paramprefix && this.item.paramprefix.length)
      this.prefix += this.item.paramprefix + "/"
    this.getColumns(this.item.columns, this.columns);
  }

  processData() {
    let processed = this.bulk_data;
    this.bulk_data = "";
    let data: Array<any> = processed.split(/\n/g);
    let subarrays = [];
    this.getColumns(this.item.columns, subarrays);
    console.log(subarrays);
    let mapped = data.filter(line => line.length > 0).map((line) => {
      let i = 0;
      let item = {};
      let datas = line.split(/\t/g)
      subarrays.forEach((c) => {
        item[c.parent ? (c.parent + "." + c['data']) : c['data']] = this.cleanValue(datas[i]);
        i++;
      });
      return item;
    });
    console.log(JSON.stringify(mapped, null, 2))
    if (this.hasSubArray) {
      console.log(this.item.columns)
      let arrays = [];
      this.item.columns.filter(c => c.columns && c.columns.length > 0).forEach(c => {
        mapped.forEach(i => {
          console.log(i)
          console.log(c)
          let item = arrays.find(arr => arr['value'] == i[c['data']])
          console.log("item",item);
          if (!item) {
            item = { "content": [], "value": i[c['data']], column: c };
            arrays.push(item);
          }
          item.content.push(i);
        });
      })



      console.log(arrays);

      mapped = arrays.map(ar => {
        let base = ar.content[0];
        let key = ar.column.sub_key;
        base[key] = [];
        ar.content.forEach(con => {
          let su = {};
          ar.column.columns.forEach(c => {
            su[c.data] = con[c.parent ? (c.parent + "." + c['data']) : c['data']];
            delete base[c.parent ? (c.parent + "." + c['data']) : c['data']];
          });
          base[key].push(su);
        });
        delete base.column;
        return base;
      })
    }

    console.log(JSON.stringify(mapped, null, 2))
    if (this.item.input_type === 'array') {
      this.itemsService.updateValue((this.prefix ? this.prefix : '') + this.item['array_param'], mapped, this.info);
    } else if (this.item.input_type === 'children') {
      console.log(mapped)
      this.mapped = mapped;

    }
  }

  public importFile(event) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      console.log('csv content', e.target.result);
      this.bulk_data = e.target.result as string;
    };
    reader.readAsText(event.target.files[0]);
  }

  createFromData() {
      let toCreate = this.createItems(this.mapped, this.item.columns, this.item.create_type);
   this.syncCreate(toCreate, 0, this.info, r => {
        console.log("completed");
      })
  }
  add(arr) {
    arr.push({});
  }
  remove(arr, item) {
    let i = arr.indexOf(item);
    arr.splice(i, 1);
  }
  cleanValue(val: any): any {
    let value: any = val;
    //Remove grouping quotes from around csv/tsv
    value = value.replace(/^"|"$/g, '');
    //Remove whitespace surrounding string
    value = value.replace(/^\s*|\s$/g, '');
    //convert whole numbers to integrers
    if (value.match(/^\d+$/))
      value = parseInt(value);
    //convert decimal numbers to floats
    else if (value.match(/^\d*\.+\d+$/))
      value = parseFloat(value);
    //Covert positive indicators to true boolean
    else if (value.match(/^(true)|(yes)$/i))
      value = true;
    //Covert negative indicators to false boolean
    else if (value.match(/^(false)|(no)$/i))
      value = true;
    console.log(val);
    console.log(value)
    return value;
  }

  getColumns(array, columns, parent?) {
    console.log(array);
    array.forEach((c) => {
      c.parent = parent;
      columns.push(c);
      if (c.columns && c.columns.length) {
        this.hasSubArray = true;
        this.getColumns(c.columns, columns, parent ? (parent + "." + c['sub_key']) : c['sub_key']);
      }
    });

  }


  createItems(mapped, columns, type) {
    let toCreate = [];
    mapped.forEach(m=> {
      let item = {
        type: type, data: {}, children: [], map : m
      }
      toCreate.push(item);
      columns.forEach(c => {
        item.data[c.data] = m[c.data];
        if (c.columns && c.columns.length > 0) {
          item.children = this.createItems(m[c.sub_key], c.columns, c.sub_key);
        }
      });
    })
    return toCreate;
  }

  syncCreate(items, index, parent, completed) {
    if (index < items.length) {
      let item = items[index];
      this.createData(item.type, item.data, parent).subscribe(resp => {
        let ind = this.mapped.indexOf(item.map);
        this.mapped.splice(ind, 1);
        this.created.push(item.map);
        if (item.children) {
          this.syncCreate(item.children, 0, resp, r => {
            this.syncCreate(items, index + 1, parent, completed)
          })
        }
        this.update();
      });
    } else {
      completed();
    }
  }

  createData(type, data, parent) {
    console.log(this.item);
    var default_data = {
      type: type,
      data: data
    }
    var path = "";
    if (parent && parent.type && parent.id)
      path = parent.type + '/' + parent.id + '/';
    path += type
    /* let placeholder = ({
       type: type,
       data: {
         content: [{

           type: 'text',
           value: default_data.data['title'] || type
         }
         ]
       }
     })
     this.viewUpdate.triggerListChange({ "list_type": 'list', placeholder: placeholder, "type": type, parent_type: this.info.type, parent_id: this.info.id })*/

    return this.itemsService.createData(path, default_data)/*.subscribe(d => {
          console.log(d)
          if (this.info) {
            console.log("update new item")
            this.viewUpdate.triggerListChange({ "list_type": 'list', "type": type, "added": d, parent_type: this.info.type, parent_id: this.info.id })
          }
        });*/


  }


}
